exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__Textfield__button_eye {\n  color: #95a0b3;\n  visibility: hidden;\n}\n\n  .DS__Textfield__button_eye_show {\n    visibility: visible;\n  }\n\n.DS__Textfield__success {\n  color: #97ba1e;\n  visibility: hidden;\n}\n\n.DS__Textfield__success_show {\n    visibility: visible;\n  }\n", ""]);

// exports
exports.locals = {
	"button_eye": "DS__Textfield__button_eye",
	"button_eye_show": "DS__Textfield__button_eye_show",
	"success": "DS__Textfield__success",
	"success_show": "DS__Textfield__success_show"
};